// app/javascript/controllers/comment_reply_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    bodyJson: Object,
    commentId: Number,
  }

  reply() {
    this.element.dispatchEvent(
      new CustomEvent("comment:reply", {
        bubbles: true,
        detail: {
          bodyJson: this.bodyJsonValue,
          commentId: this.commentIdValue,
        },
      })
    )
  }
}
